"use client";
import { Breadcrumbs } from "@wojo/web-components";
import styles from "./AccountBreadcrumbs.module.scss";

export type AccountBreadcrumbsProps = {
    items: { link: string; text: string }[];
};

export const AccountBreadcrumbs: React.FC<AccountBreadcrumbsProps> = ({
    items,
}) => {
    return (
        <div>
            <Breadcrumbs
                className={styles["wrapper"]}
                items={items}
                withNextLink
            />
        </div>
    );
};
